// extracted by mini-css-extract-plugin
export default {"questionType":"index_questionType_boTYk clearfix","arrow":"index_arrow_n5QMD","show":"index_show_Hlbr-","error":"index_error_vq2yG","defaultStyle":"index_defaultStyle_-aVTW"};